import React, { useState, useRef, useEffect, useCallback } from 'react';
import { API_URL } from '../config';
import '../styles/Games.css';
import TokenWheelPanel from './TokenWheel';

// 13 segments : 2× chaque valeur + 1 JACKPOT — ordre IDENTIQUE au serveur (gameController.ts)
// Probas par valeur inchangées : 0=57% 20=18% 40=10% 60=5% 75=3% 100=2% JACKPOT=5%
const SEGMENTS = [
  { label: '0',       value: 0,   color: '#12001f', textColor: '#555',    isJackpot: false },  //  0
  { label: '20',      value: 20,  color: '#1A1A2E', textColor: '#7986CB', isJackpot: false },  //  1
  { label: '40',      value: 40,  color: '#1B2838', textColor: '#78909C', isJackpot: false },  //  2
  { label: '60',      value: 60,  color: '#0D3350', textColor: '#64B5F6', isJackpot: false },  //  3
  { label: '75',      value: 75,  color: '#1B5E20', textColor: '#A5D6A7', isJackpot: false },  //  4
  { label: '100',     value: 100, color: '#B71C1C', textColor: '#FFCDD2', isJackpot: false },  //  5
  { label: 'JACKPOT', value: 500, color: '#F57F17', textColor: '#fff',    isJackpot: true  },  //  6
  { label: '0',       value: 0,   color: '#12001f', textColor: '#555',    isJackpot: false },  //  7
  { label: '20',      value: 20,  color: '#1A1A2E', textColor: '#7986CB', isJackpot: false },  //  8
  { label: '40',      value: 40,  color: '#1B2838', textColor: '#78909C', isJackpot: false },  //  9
  { label: '60',      value: 60,  color: '#0D3350', textColor: '#64B5F6', isJackpot: false },  // 10
  { label: '75',      value: 75,  color: '#1B5E20', textColor: '#A5D6A7', isJackpot: false },  // 11
  { label: '100',     value: 100, color: '#B71C1C', textColor: '#FFCDD2', isJackpot: false },  // 12
];

const NUM_SEG   = SEGMENTS.length;
const SEG_ANGLE = (2 * Math.PI) / NUM_SEG;
const SIZE      = 400;
const CX        = SIZE / 2;
const CY        = SIZE / 2;
const RADIUS    = 172;
const INIT_ROT  = -Math.PI / 2 - SEG_ANGLE / 2;

// ── Éclairs temporels (midpoint displacement) ──────────────────────────────
function boltPoints(x1, y1, x2, y2, depth) {
  if (depth <= 0) return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
  const mx = (x1 + x2) / 2 + (Math.random() - 0.5) * depth * 14;
  const my = (y1 + y2) / 2 + (Math.random() - 0.5) * depth * 14;
  const left  = boltPoints(x1, y1, mx, my, depth - 1);
  const right = boltPoints(mx, my, x2, y2, depth - 1);
  right.shift();
  return [...left, ...right];
}

function drawBoltPath(ctx, pts, alpha, color) {
  if (pts.length < 2) return;
  ctx.save();
  ctx.globalAlpha = Math.max(0, Math.min(1, alpha));
  // Halo lumineux
  ctx.strokeStyle = color; ctx.lineWidth = 2.2;
  ctx.shadowColor = color; ctx.shadowBlur = 22;
  ctx.beginPath(); ctx.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
  ctx.stroke();
  // Cœur blanc brillant
  ctx.strokeStyle = 'rgba(255,255,255,0.88)'; ctx.lineWidth = 0.7; ctx.shadowBlur = 5;
  ctx.beginPath(); ctx.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
  ctx.stroke();
  ctx.restore();
}

function drawFrame(ctx, rotation) {
  ctx.clearRect(0, 0, SIZE, SIZE);
  ctx.beginPath(); ctx.arc(CX, CY, RADIUS + 8, 0, 2 * Math.PI);
  ctx.fillStyle = '#0d0121'; ctx.fill();

  SEGMENTS.forEach((seg, i) => {
    const a0 = rotation + i * SEG_ANGLE, a1 = a0 + SEG_ANGLE;
    ctx.beginPath(); ctx.moveTo(CX, CY); ctx.arc(CX, CY, RADIUS, a0, a1); ctx.closePath();
    ctx.fillStyle = seg.color; ctx.fill();
    ctx.strokeStyle = 'rgba(0,0,0,0.55)'; ctx.lineWidth = 1.8; ctx.stroke();
    ctx.save(); ctx.translate(CX, CY); ctx.rotate(a0 + SEG_ANGLE / 2);
    if (seg.isJackpot) {
      ctx.fillStyle = seg.textColor;
      ctx.textAlign = 'right';
      ctx.font = 'bold 10px Segoe UI,Arial,sans-serif'; ctx.fillText('JACKPOT', RADIUS - 8, -5);
      ctx.font = '9px Segoe UI,Arial,sans-serif';
      ctx.textAlign = 'left';
      const tw5 = ctx.measureText('500').width;
      const sx5 = RADIUS - 8 - tw5 - 10;
      ctx.fillText('500', sx5, 7);
      if (ogImgEl.complete && ogImgEl.naturalWidth) ctx.drawImage(ogImgEl, sx5 + tw5 + 1, 0, 9, 9);
    } else {
      const txt = seg.value === 0 ? '0' : String(seg.value);
      ctx.font = 'bold 13px Segoe UI,Arial,sans-serif'; ctx.fillStyle = seg.textColor;
      ctx.textAlign = 'left';
      const tw = ctx.measureText(txt).width;
      const sx = RADIUS - 8 - tw - 12;
      ctx.fillText(txt, sx, 5);
      if (ogImgEl.complete && ogImgEl.naturalWidth) ctx.drawImage(ogImgEl, sx + tw + 1, -5, 11, 11);
    }
    ctx.restore();
  });

  ctx.beginPath(); ctx.arc(CX, CY, RADIUS, 0, 2 * Math.PI);
  ctx.strokeStyle = 'rgba(255,215,0,0.55)'; ctx.lineWidth = 4; ctx.stroke();

  for (let i = 0; i < NUM_SEG; i++) {
    const angle = rotation + i * SEG_ANGLE;
    ctx.save(); ctx.translate(CX, CY); ctx.rotate(angle);
    ctx.beginPath(); ctx.moveTo(RADIUS - 4, 0); ctx.lineTo(RADIUS + 7, 0);
    ctx.strokeStyle = 'rgba(255,215,0,0.7)'; ctx.lineWidth = 2; ctx.stroke(); ctx.restore();
  }

  const grd = ctx.createRadialGradient(CX - 5, CY - 5, 2, CX, CY, 22);
  grd.addColorStop(0, '#666'); grd.addColorStop(1, '#111');
  ctx.beginPath(); ctx.arc(CX, CY, 22, 0, 2 * Math.PI);
  ctx.fillStyle = grd; ctx.fill(); ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2.5; ctx.stroke();

  const tipY = CY - RADIUS + 4;
  ctx.beginPath(); ctx.moveTo(CX, tipY); ctx.lineTo(CX - 13, tipY - 26); ctx.lineTo(CX + 13, tipY - 26);
  ctx.closePath(); ctx.fillStyle = '#FFD700'; ctx.fill();
  ctx.strokeStyle = 'rgba(255,255,255,0.85)'; ctx.lineWidth = 1.5; ctx.stroke();
}

// ── Préchargement de l'icône ogrines (module level) ──────────────────────────
const ogImgEl = new Image();
ogImgEl.src = '/assets/images/1.png';

// Composant icône ogrines réutilisable
function OgIcon({ size = 16 }) {
  return <img src="/assets/images/1.png" alt="og" className="og-icon" style={{ width: size, height: size }} />;
}

// ── Animation jackpot : faille temporelle + explosion d'ogrines ──────────────
const CRACK_COLORS = ['#00E5FF', '#B45FFF', '#E040FB', '#40C4FF', '#7C4DFF'];

function playJackpotVFX(mainCanvas, overlayCanvas, finalRotation, onComplete) {
  if (!mainCanvas || !overlayCanvas) { onComplete(); return; }
  const mc   = mainCanvas.getContext('2d');
  const oc   = overlayCanvas.getContext('2d');
  const t0   = performance.now();
  const TOTAL = 3800;

  // Fissures pré-générées depuis le centre
  const cracks = Array.from({ length: 12 }, () => {
    const a = Math.random() * Math.PI * 2;
    const r = 18 + Math.random() * RADIUS;
    return {
      pts:   boltPoints(CX, CY, CX + Math.cos(a) * r, CY + Math.sin(a) * r, 3),
      color: CRACK_COLORS[Math.floor(Math.random() * CRACK_COLORS.length)],
    };
  });

  // Particules ogrines qui jaillissent du centre
  const particles = Array.from({ length: 50 }, (_, i) => {
    const a   = (i / 50) * Math.PI * 2 + (Math.random() - 0.5) * 0.6;
    const spd = 2.5 + Math.random() * 8;
    return {
      x: CX, y: CY,
      vx: Math.cos(a) * spd,
      vy: Math.sin(a) * spd - 2.5,
      grav: 0.16 + Math.random() * 0.12,
      rot:  Math.random() * Math.PI * 2,
      rotV: (Math.random() - 0.5) * 0.28,
      size: 14 + Math.random() * 20,
      delay: 450 + Math.random() * 450,
    };
  });

  let rafId;
  const frame = (now) => {
    const el   = now - t0;
    const prog = Math.min(el / TOTAL, 1);
    mc.clearRect(0, 0, SIZE, SIZE);
    oc.clearRect(0, 0, SIZE, SIZE);

    if (prog < 0.22) {
      // Phase 1 — tremblement + fissures grandissantes
      const p  = prog / 0.22;
      const sh = (Math.random() - 0.5) * p * 10;
      const sv = (Math.random() - 0.5) * p * 8;
      mc.save(); mc.translate(sh, sv);
      drawFrame(mc, finalRotation);
      mc.restore();
      for (const c of cracks) {
        const n = Math.max(2, Math.floor(c.pts.length * p));
        drawBoltPath(oc, c.pts.slice(0, n), p * 0.85, c.color);
      }
    } else if (prog < 0.58) {
      // Phase 2 — fragmentation : segments volent vers l'extérieur
      const p = (prog - 0.22) / 0.36;
      mc.fillStyle = `rgba(13,1,33,${p * 0.98})`;
      mc.fillRect(0, 0, SIZE, SIZE);

      // Hub
      const g = mc.createRadialGradient(CX-4, CY-4, 2, CX, CY, 22);
      g.addColorStop(0, '#666'); g.addColorStop(1, '#111');
      mc.beginPath(); mc.arc(CX, CY, 22 * (1 - p * 0.5), 0, Math.PI * 2);
      mc.fillStyle = g; mc.fill();

      // Halo d'explosion
      const hr  = p * RADIUS * 1.4;
      const hg  = mc.createRadialGradient(CX, CY, 0, CX, CY, Math.max(1, hr));
      hg.addColorStop(0, `rgba(0,229,255,${(1 - p) * 0.9})`);
      hg.addColorStop(0.5, `rgba(180,95,255,${(1 - p) * 0.5})`);
      hg.addColorStop(1, 'rgba(0,0,0,0)');
      mc.beginPath(); mc.arc(CX, CY, Math.max(1, hr), 0, Math.PI * 2);
      mc.fillStyle = hg; mc.fill();

      // Segments qui s'envolent
      SEGMENTS.forEach((seg, i) => {
        const a0   = finalRotation + i * SEG_ANGLE;
        const a1   = a0 + SEG_ANGLE;
        const midA = a0 + SEG_ANGLE / 2;
        const off  = p * 90 + p * p * 60;
        mc.save();
        mc.translate(Math.cos(midA) * off, Math.sin(midA) * off);
        mc.globalAlpha = 1 - p * 0.97;
        mc.beginPath(); mc.moveTo(CX, CY); mc.arc(CX, CY, RADIUS, a0, a1); mc.closePath();
        mc.fillStyle = seg.color; mc.fill();
        mc.strokeStyle = seg.isJackpot ? '#FFD700' : 'rgba(0,229,255,0.5)';
        mc.lineWidth = 2; mc.stroke();
        mc.restore();
      });
      for (const c of cracks) drawBoltPath(oc, c.pts, (1 - p) * 0.7, c.color);
    } else {
      // Phase 3 — vide avec halo résiduel
      const p = (prog - 0.58) / 0.42;
      mc.fillStyle = '#0d0121'; mc.fillRect(0, 0, SIZE, SIZE);
      const hr = RADIUS * (0.7 + p * 0.55);
      const hg = mc.createRadialGradient(CX, CY, 0, CX, CY, Math.max(1, hr));
      hg.addColorStop(0, `rgba(0,229,255,${(1-p)*0.35})`);
      hg.addColorStop(1, 'rgba(0,0,0,0)');
      mc.beginPath(); mc.arc(CX, CY, Math.max(1, hr), 0, Math.PI * 2);
      mc.fillStyle = hg; mc.fill();
    }

    // Particules ogrines (à partir de ~450ms)
    if (el > 380) {
      const partEl = el - 380;
      for (const p of particles) {
        const t = (partEl - p.delay) / 1000;
        if (t < 0 || !ogImgEl.complete || !ogImgEl.naturalWidth) continue;
        const px    = p.x + p.vx * t * 55;
        const py    = p.y + p.vy * t * 55 + 0.5 * p.grav * (t * 55) ** 2;
        const alpha = Math.max(0, 1 - t / ((TOTAL - 380) / 1000));
        if (alpha <= 0) continue;
        oc.save();
        oc.globalAlpha = alpha;
        oc.translate(px, py);
        oc.rotate(p.rot + p.rotV * t * 55);
        oc.drawImage(ogImgEl, -p.size / 2, -p.size / 2, p.size, p.size);
        oc.restore();
      }
    }

    if (prog < 1) {
      rafId = requestAnimationFrame(frame);
    } else {
      oc.clearRect(0, 0, SIZE, SIZE);
      drawFrame(mc, finalRotation);
      onComplete();
    }
  };
  rafId = requestAnimationFrame(frame);
}

// Images de prévisualisation pour chaque récompense du Coffre Temporel
const COFFRE_ITEM_IMGS = {
  'Panoplie Tooschuss': '/assets/Items/Tooschuss/Bonnet Tooshuss.webp',
  'Panoplie Kitsoune': '/assets/Items/Coffre Temporel.png',
  'Panoplie Loterie Turquoise': '/assets/Items/Coffre Temporel.png',
  'Panoplie Subtile': '/assets/Items/Coffre Temporel.png',
};

const COFFRE_TEMPOREL_ENABLED = false;

export default function Games() {
  const canvasRef      = useRef(null);
  const overlayRef     = useRef(null);
  const rotRef         = useRef(INIT_ROT);
  const rafRef         = useRef(null);
  const overlayAnimRef = useRef(null);
  const boltPoolRef    = useRef([]);
  const boltCleanupRef = useRef(null);
  const [jackpotVfx,  setJackpotVfx]  = useState(false);

  const [spinning,     setSpinning]     = useState(false);
  const [result,       setResult]       = useState(null);
  const [balance,      setBalance]      = useState(null);
  const [history,      setHistory]      = useState([]);
  const [leaderboard,  setLeaderboard]  = useState([]);
  const [error,        setError]        = useState(null);
  const [spinsToday,   setSpinsToday]   = useState(null);
  const [ogSpent,      setOgSpent]      = useState(0);
  const [coffresOuverts, setCoffresOuverts] = useState(0);
  const [coffreMsg,       setCoffreMsg]       = useState('');
  const [coffreAnimPhase, setCoffreAnimPhase] = useState(null); // null | 'shaking' | 'opening' | 'done'
  const [coffreWonItem,   setCoffreWonItem]   = useState(null);
  const [multiResults,    setMultiResults]    = useState(null);

  const user         = JSON.parse(localStorage.getItem('user') || 'null');
  const sessionToken = localStorage.getItem('sessionToken');
  const isLoggedIn   = !!(user && sessionToken);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    drawFrame(canvas.getContext('2d'), rotRef.current);
  }, []);

  useEffect(() => {
    if (user) setBalance(user.ogrines ?? 0);
  }, []); // eslint-disable-line

  const loadLeaderboard = useCallback(async () => {
    try {
      const r = await fetch(API_URL + '/games/leaderboard');
      const d = await r.json();
      if (d.success) setLeaderboard(d.leaderboard);
    } catch (_) {}
  }, []);

  useEffect(() => {
    loadLeaderboard();
    const iv = setInterval(loadLeaderboard, 30000);
    return () => clearInterval(iv);
  }, [loadLeaderboard]);

  // Charge le compteur de lancers du jour + ogrines dépensées au montage
  useEffect(() => {
    if (!isLoggedIn || !sessionToken) return;
    fetch(API_URL + '/games/status', {
      headers: { 'Authorization': 'Bearer ' + sessionToken },
    })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setSpinsToday(d.spinsToday);
          setOgSpent(d.ogrinesSpent ?? 0);
          setCoffresOuverts(d.coffresOuverts ?? 0);
        }
      })
      .catch(() => {});
  }, []); // eslint-disable-line

  // Écoute les achats de jetons depuis TokenWheel (mise à jour jauge en temps réel)
  useEffect(() => {
    const handler = (e) => setOgSpent(e.detail.ogrinesSpent);
    window.addEventListener('ogSpentUpdate', handler);
    return () => window.removeEventListener('ogSpentUpdate', handler);
  }, []);

  const animateToSegment = useCallback((segIdx, onDone) => {
    const targetBase = -Math.PI / 2 - segIdx * SEG_ANGLE - SEG_ANGLE / 2;
    let targetRot = targetBase;
    const numSpins = 5 + Math.floor(Math.random() * 3);
    while (targetRot < rotRef.current + numSpins * 2 * Math.PI) targetRot += 2 * Math.PI;
    const startRot = rotRef.current, delta = targetRot - startRot;
    const duration = 4500, t0 = performance.now();
    const easeOut = t => 1 - Math.pow(1 - t, 4);
    const ctx = canvasRef.current.getContext('2d');

    // ── Éclairs temporels ──────────────────────────────────────────────────
    boltPoolRef.current = [];
    const BOLT_COLORS = ['#B45FFF', '#00E5FF', '#E040FB', '#00BCD4', '#7C4DFF', '#40C4FF'];
    const spawnBolt = () => {
      const angle  = Math.random() * Math.PI * 2;
      const angle2 = angle + (Math.random() - 0.5) * 0.7;
      const r1 = 10 + Math.random() * 24;
      const r2 = 60 + Math.random() * 110;
      boltPoolRef.current.push({
        pts:   boltPoints(
          CX + Math.cos(angle)  * r1, CY + Math.sin(angle)  * r1,
          CX + Math.cos(angle2) * r2, CY + Math.sin(angle2) * r2, 3
        ),
        color: BOLT_COLORS[Math.floor(Math.random() * BOLT_COLORS.length)],
        born:  performance.now(),
        life:  120 + Math.random() * 120,
      });
    };
    spawnBolt();
    const boltIv = setInterval(spawnBolt, 80);

    const overlayLoop = (now) => {
      const oc = overlayRef.current;
      if (!oc) return;
      const octx = oc.getContext('2d');
      boltPoolRef.current = boltPoolRef.current.filter(b => now - b.born < b.life);
      octx.clearRect(0, 0, SIZE, SIZE);
      for (const b of boltPoolRef.current) {
        const age   = (now - b.born) / b.life;
        const alpha = age < 0.15 ? age / 0.15 : 1 - (age - 0.15) / 0.85;
        drawBoltPath(octx, b.pts, alpha, b.color);
      }
      overlayAnimRef.current = requestAnimationFrame(overlayLoop);
    };
    overlayAnimRef.current = requestAnimationFrame(overlayLoop);
    // ──────────────────────────────────────────────────────────────────────

    const animate = (now) => {
      const prog = Math.min((now - t0) / duration, 1);
      rotRef.current = startRot + delta * easeOut(prog);
      drawFrame(ctx, rotRef.current);
      if (prog < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        rotRef.current = targetRot;
        drawFrame(ctx, rotRef.current);
        clearInterval(boltIv);
        // Laisse les derniers éclairs disparaître en fondu (annulable si jackpot VFX prend le relai)
        boltCleanupRef.current = setTimeout(() => {
          cancelAnimationFrame(overlayAnimRef.current);
          const oc = overlayRef.current;
          if (oc) oc.getContext('2d').clearRect(0, 0, SIZE, SIZE);
        }, 450);
        onDone();
      }
    };
    rafRef.current = requestAnimationFrame(animate);
  }, []);

  const spin = useCallback(async () => {
    if (spinning || !isLoggedIn) return;
    setSpinning(true); setResult(null); setMultiResults(null); setError(null);
    try {
      const resp = await fetch(API_URL + '/games/spin', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + sessionToken, 'Content-Type': 'application/json' },
      });
      const data = await resp.json();
      if (!data.success) {
        setError(data.message || 'Erreur serveur.');
        setSpinning(false);
        return;
      }
      animateToSegment(data.segmentIndex, () => {
        const applyResults = () => {
          setResult({ ...SEGMENTS[data.segmentIndex], ...data });
          setBalance(data.newBalance);
          const stored = JSON.parse(localStorage.getItem('user') || '{}');
          stored.ogrines = data.newBalance;
          localStorage.setItem('user', JSON.stringify(stored));
          window.dispatchEvent(new Event('storage'));
          setSpinsToday(data.spinsToday ?? (prev => (prev ?? 0) + 1));
          if (data.ogrinesSpent !== undefined) setOgSpent(data.ogrinesSpent);
          if (data.coffresOuverts !== undefined) setCoffresOuverts(data.coffresOuverts);
          if (data.isJackpot) {
            window.dispatchEvent(new CustomEvent('jackpot-won', {
              detail: { username: data.username }
            }));
          }
          setHistory(prev =>
            [{ won: data.value, net: data.net, ts: new Date().toLocaleTimeString(), isJackpot: data.isJackpot }, ...prev].slice(0, 12)
          );
          setSpinning(false);
          setJackpotVfx(false);
          loadLeaderboard();
        };

        if (data.isJackpot) {
          // Annuler le nettoyage différé des éclairs : la VFX prend le relai
          clearTimeout(boltCleanupRef.current);
          cancelAnimationFrame(overlayAnimRef.current);
          setJackpotVfx(true);
          playJackpotVFX(canvasRef.current, overlayRef.current, rotRef.current, applyResults);
        } else {
          applyResults();
        }
      });
    } catch (_) { setError('Impossible de contacter le serveur.'); setSpinning(false); }
  }, [spinning, isLoggedIn, sessionToken, animateToSegment, loadLeaderboard]);

  // ── Spin ×5 ───────────────────────────────────────────────────────────
  const spin5 = useCallback(async () => {
    if (spinning || !isLoggedIn) return;
    setSpinning(true); setResult(null); setMultiResults(null); setError(null);
    try {
      const resp = await fetch(API_URL + '/games/spin-multi', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + sessionToken, 'Content-Type': 'application/json' },
      });
      const data = await resp.json();
      if (!data.success) {
        setError(data.message || 'Erreur serveur.');
        setSpinning(false);
        return;
      }
      // Anime la roue vers le dernier segment
      const lastResult = data.results[data.results.length - 1];
      animateToSegment(lastResult.segmentIndex, () => {
        setMultiResults(data);
        setBalance(data.newBalance);
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        stored.ogrines = data.newBalance;
        localStorage.setItem('user', JSON.stringify(stored));
        window.dispatchEvent(new Event('storage'));
        setSpinsToday(data.spinsToday);
        if (data.ogrinesSpent !== undefined) setOgSpent(data.ogrinesSpent);
        if (data.coffresOuverts !== undefined) setCoffresOuverts(data.coffresOuverts);
        if (data.results.some(r => r.isJackpot)) {
          window.dispatchEvent(new CustomEvent('jackpot-won', { detail: { username: data.username } }));
        }
        setHistory(prev =>
          [
            ...data.results.map(r => ({ won: r.value, net: r.net, ts: new Date().toLocaleTimeString(), isJackpot: r.isJackpot })),
            ...prev,
          ].slice(0, 12)
        );
        setSpinning(false);
        setJackpotVfx(false);
        loadLeaderboard();
      });
    } catch (_) { setError('Impossible de contacter le serveur.'); setSpinning(false); }
  }, [spinning, isLoggedIn, sessionToken, animateToSegment, loadLeaderboard]);

  const dailyLimitReached = spinsToday !== null && spinsToday >= 100;
  const canSpin = isLoggedIn && !spinning && !dailyLimitReached && (balance === null || balance >= 50);
  const canSpin5 = isLoggedIn && !spinning && spinsToday !== null && (100 - spinsToday) >= 5 && balance !== null && balance >= 250;
  const resultClass = result ? (result.isJackpot ? 'jackpot' : result.value > 50 ? 'win' : result.value === 50 ? 'push' : 'lose') : '';

  const spinBtnLabel = () => {
    if (spinning) return 'La roue tourne...';
    if (dailyLimitReached) return 'Limite journalière atteinte';
    if (balance !== null && balance < 50) return 'Ogrines insuffisantes';
    return <span>Lancer — -50 <OgIcon size={14} /></span>;
  };

  const spinBtnLabel5 = () => {
    if (spinning) return 'La roue tourne...';
    if (spinsToday !== null && (100 - spinsToday) < 5) return 'Plus assez de lancers';
    if (balance !== null && balance < 250) return `x5 (besoin de 250 )`;
    return <span>Lancer ×5 — -250 <OgIcon size={14} /></span>;
  };

  const [activeTab, setActiveTab] = useState('ogrines');

  const coffresDisponibles = Math.floor(ogSpent / 10000) - coffresOuverts;
  // Progress dans le cycle actuel de 10 000 ogrines
  const ogCycle = ogSpent % 10000;
  const ogProgress = (coffresDisponibles > 0 && ogCycle === 0) ? 10000 : ogCycle;

  const handleOpenCoffre = useCallback(async () => {
    if (!COFFRE_TEMPOREL_ENABLED) return;
    if (coffreAnimPhase !== null || coffresDisponibles <= 0 || !isLoggedIn) return;
    const wait = (ms) => new Promise(r => setTimeout(r, ms));
    setCoffreAnimPhase('shaking');
    setCoffreWonItem(null);
    setCoffreMsg('');
    // API + minimum shake en parallèle
    const [data] = await Promise.all([
      fetch(API_URL + '/games/coffre-temporel/open', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + sessionToken },
      })
        .then(r => r.json())
        .catch(() => ({ success: false, message: 'Impossible de contacter le serveur.' })),
      wait(1050),
    ]);
    if (!data.success) {
      setCoffreAnimPhase(null);
      setCoffreMsg(data.message || 'Erreur lors de l\'ouverture.');
      return;
    }
    setCoffresOuverts(data.coffresOuverts);
    setCoffreWonItem(data.itemWon);
    setCoffreAnimPhase('opening');
    await wait(850);
    setCoffreAnimPhase('done');
  }, [coffreAnimPhase, coffresDisponibles, isLoggedIn, sessionToken]);

  return (
    <div className="games-page">
      <div className="games-header">
        <h1>Jeux</h1>
      </div>

      {/* ── Jauge Coffre Temporel ── */}
      {COFFRE_TEMPOREL_ENABLED && isLoggedIn && (
        <div style={{
          maxWidth: 540, margin: '0 auto 20px',
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,215,0,0.2)',
          borderRadius: 14, padding: '12px 16px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src="/assets/Items/Clef Temporelle.png" alt="clef" style={{ width: 26, height: 26, objectFit: 'contain' }} />
              <span style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.75)', fontWeight: 600 }}>Coffre Temporel</span>
            </div>
            <span style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.45)', display: 'flex', alignItems: 'center', gap: 3 }}>
              {ogProgress.toLocaleString('fr-FR')} / 10 000 <OgIcon size={11} />
            </span>
          </div>
          {/* Barre de progression + coffre cliquable à droite */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ flex: 1, background: 'rgba(0,0,0,0.35)', borderRadius: 8, height: 14, overflow: 'hidden' }}>
              <div className="og-bar-fill" style={{
                width: `${(ogProgress / 10000) * 100}%`,
                height: '100%',
              }} />
            </div>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <img
                src="/assets/Items/Coffre Temporel.png"
                alt="coffre"
                title={coffresDisponibles > 0 ? `Cliquer pour ouvrir votre coffre${coffresDisponibles > 1 ? ` (×${coffresDisponibles} dispo)` : ''} !` : 'Continuez à dépenser des ogrines !'}
                onClick={coffresDisponibles > 0 ? handleOpenCoffre : undefined}
                style={{
                  width: 40, height: 40, objectFit: 'contain', display: 'block',
                  cursor: coffresDisponibles > 0 ? 'pointer' : 'default',
                  opacity: coffresDisponibles > 0 ? 1 : 0.32,
                  filter: coffresDisponibles > 0 ? 'drop-shadow(0 0 8px rgba(255,215,0,0.65))' : 'grayscale(1)',
                  transition: 'opacity 0.3s, filter 0.3s',
                  animation: coffresDisponibles > 0 ? 'pulse 1.4s ease-in-out infinite' : 'none',
                }}
              />
              {coffresDisponibles > 1 && (
                <span style={{
                  position: 'absolute', top: -6, right: -6,
                  background: 'linear-gradient(135deg, #9C27B0, #673AB7)',
                  color: '#fff', fontWeight: 800, fontSize: '0.65rem',
                  minWidth: 18, height: 18, borderRadius: 9,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: '0 4px', boxShadow: '0 0 6px rgba(156,39,176,0.7)',
                  pointerEvents: 'none',
                }}>
                  {coffresDisponibles}
                </span>
              )}
            </div>
          </div>
          {coffreMsg && (
            <p style={{ fontSize: '0.78rem', color: '#A0D080', margin: '8px 0 0', textAlign: 'center' }}>{coffreMsg}</p>
          )}
        </div>
      )}

      {/* ── Overlay animation coffre ── */}
      {COFFRE_TEMPOREL_ENABLED && coffreAnimPhase !== null && (
        <div className="coffre-overlay">
          <div className="coffre-scene">
            <div className={`coffre-box${coffreAnimPhase === 'shaking' ? ' shaking' : ''}`}>
              {/* Couvercle (moitié haute) */}
              <div className={`coffre-lid${coffreAnimPhase === 'opening' || coffreAnimPhase === 'done' ? ' open' : ''}`}>
                <img src="/assets/Items/Coffre Temporel.png" alt="" style={{ width: 160, height: 160, objectFit: 'contain', display: 'block' }} />
              </div>
              {/* Base (moitié basse) */}
              <div className="coffre-base">
                <img src="/assets/Items/Coffre Temporel.png" alt="" style={{ width: 160, height: 160, objectFit: 'contain', display: 'block' }} />
              </div>
              {/* Particules dorées lors de l'ouverture */}
              {(coffreAnimPhase === 'opening' || coffreAnimPhase === 'done') && Array.from({ length: 12 }, (_, i) => {
                const angle = (i / 12) * 2 * Math.PI;
                const dist  = 55 + (i % 3) * 25;
                return (
                  <div key={i} className="coffre-particle" style={{
                    '--tx': `${Math.cos(angle) * dist}px`,
                    '--ty': `${Math.sin(angle) * dist}px`,
                    marginLeft: `${-4 + Math.cos(angle) * 4}px`,
                    marginTop:  `${-4 + Math.sin(angle) * 4}px`,
                    background: i % 3 === 0 ? '#FFD700' : i % 3 === 1 ? '#FFA500' : '#fff',
                    width: `${6 + (i % 3) * 3}px`, height: `${6 + (i % 3) * 3}px`,
                    animationDelay: `${(i % 4) * 0.06}s`,
                  }} />
                );
              })}
            </div>

            {/* Résultat après ouverture */}
            {coffreAnimPhase === 'done' && coffreWonItem && (
              <>
                <div className="coffre-result-title">🎁 Coffre Temporel ouvert !</div>
                <div className="coffre-prize">
                  <img
                    src={COFFRE_ITEM_IMGS[coffreWonItem] || '/assets/Items/Coffre Temporel.png'}
                    alt={coffreWonItem}
                    style={{ width: 90, height: 90, objectFit: 'contain', filter: 'drop-shadow(0 0 16px rgba(255,215,0,0.6))' }}
                  />
                  <span style={{ fontWeight: 700, fontSize: '1.1rem', color: '#fff', textAlign: 'center' }}>
                    {coffreWonItem}
                  </span>
                  <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', textAlign: 'center' }}>
                    Votre récompense vous attend en jeu !
                  </span>
                </div>
                <button className="coffre-close-btn" onClick={() => { setCoffreAnimPhase(null); setCoffreWonItem(null); }}>
                  Fermer
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── Onglets ── */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 24, justifyContent: 'center', flexWrap: 'wrap' }}>
        <button
          onClick={() => setActiveTab('ogrines')}
          style={{
            flex: '1 1 140px', maxWidth: 220,
            padding: '8px 22px',
            background: activeTab === 'ogrines' ? 'rgba(255,215,0,0.18)' : 'rgba(255,255,255,0.06)',
            border: activeTab === 'ogrines' ? '1px solid rgba(255,215,0,0.5)' : '1px solid rgba(255,255,255,0.15)',
            borderRadius: 10, color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem',
          }}
        >
          🎡 Roulette Ogrines
        </button>
        <button
          onClick={() => setActiveTab('votes')}
          style={{
            flex: '1 1 140px', maxWidth: 220,
            padding: '8px 22px',
            background: activeTab === 'votes' ? 'rgba(180,95,255,0.18)' : 'rgba(255,255,255,0.06)',
            border: activeTab === 'votes' ? '1px solid rgba(180,95,255,0.5)' : '1px solid rgba(255,255,255,0.15)',
            borderRadius: 10, color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem',
          }}
        >
          🎟️ Roulette Votes
        </button>
      </div>

      {/* ── Onglet Roulette Votes ── */}
      <div style={{ display: activeTab === 'votes' ? '' : 'none' }}>
        <TokenWheelPanel />
      </div>

      {/* ── Onglet Roulette Ogrines (display:none pour préserver le canvas) ── */}
      <div style={{ display: activeTab === 'ogrines' ? '' : 'none' }}>
      <div className="games-layout">
        <section className="game-card roulette-section">
          <div className="gc-header">
            <div className="gc-title">
              <span className="gc-icon">🎡</span>
              <div>
                <h2>Roulette</h2>
                <span className="gc-sub">50 <OgIcon size={13} /> par lancer · 100 lancers/jour</span>
              </div>
            </div>
            {isLoggedIn && balance !== null && (
              <div className="balance-pill"><span>💰</span><strong>{balance} <OgIcon /></strong></div>
            )}
          </div>
          <div className={'wheel-wrapper' + (spinning ? ' is-spinning' : '') + (jackpotVfx ? ' jackpot-vfx' : '')}>
            <div className="wheel-ring-wrap">
              <canvas ref={canvasRef} width={SIZE} height={SIZE} className="wheel-canvas" />
              <canvas ref={overlayRef} width={SIZE} height={SIZE} className="wheel-overlay" />
            </div>
          </div>
          {isLoggedIn && (
            <div className="spins-counter">
              <div className="spins-bar-track">
                <div className="spins-bar-fill" style={{ width: `${Math.min(((spinsToday ?? 0) / 100) * 100, 100)}%` }} />
              </div>
              <span className="spins-label">
                {spinsToday ?? 0} / 100 lancers aujourd'hui
                {dailyLimitReached && <span className="spins-full"> · Limite atteinte</span>}
              </span>
            </div>
          )}
          {!isLoggedIn ? (
            <div className="auth-guard">Connectez-vous pour jouer à la roulette</div>
          ) : (
            <div className="spin-row" style={{ flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                <button
                  className={'spin-btn' + (spinning ? ' is-spinning' : '')}
                  onClick={spin}
                  disabled={!canSpin}
                  style={{ flex: 1 }}
                >
                  {spinBtnLabel()}
                </button>
                <button
                  className={'spin-btn spin-btn-x5' + (spinning ? ' is-spinning' : '')}
                  onClick={spin5}
                  disabled={!canSpin5}
                  style={{ flex: 1, background: canSpin5 ? 'linear-gradient(135deg, #9C27B0 0%, #673AB7 100%)' : undefined }}
                >
                  {spinBtnLabel5()}
                </button>
              </div>
            </div>
          )}
          {error && <div className="result-banner lose" style={{ marginTop: 12 }}>⚠️ {error}</div>}
          {result && (
            <div className={'result-banner ' + resultClass}>
              {result.isJackpot
                ? <>🎰 JACKPOT ! Vous gagnez 500 <OgIcon /> !</>
                : result.value > 50
                  ? <>✅ Gagné +{result.net} <OgIcon /> (retour de {result.value} <OgIcon />)</>
                  : result.value === 50
                    ? <>⚖️ Égalité — vous récupérez vos 50 <OgIcon /></>
                    : result.value === 0
                      ? <>❌ Perdu — 0 <OgIcon /> retournés (-50 <OgIcon />)</>
                      : <>❌ Perdu — retour de {result.value} <OgIcon /> (-{50 - result.value} <OgIcon />)</>}
            </div>
          )}
          {multiResults && (
            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', justifyContent: 'center', marginTop: 12 }}>
              {multiResults.results.map((r, i) => {
                const cls = r.isJackpot ? 'jackpot' : r.value > 50 ? 'win' : r.value === 50 ? 'push' : 'lose';
                return (
                  <div key={i} className={'result-banner ' + cls} style={{ flex: '1 1 80px', padding: '5px 8px', fontSize: '0.78rem', textAlign: 'center' }}>
                    {r.isJackpot ? '🎰 JACKPOT' : r.net >= 0 ? `+${r.net}` : `${r.net}`} <OgIcon size={11} />
                  </div>
                );
              })}
            </div>
          )}

        </section>

        <aside className="stats-aside">
          <div className="stats-card">
            <h3>Classement lancers</h3>
            {leaderboard.length === 0 ? (
              <p className="proba-note" style={{ marginTop: 6 }}>Aucun lancer pour l'instant.</p>
            ) : (
              <table className="proba-table" style={{ marginTop: 4 }}>
                <thead><tr><th>#</th><th>Joueur</th><th>Lancers</th><th>🎰</th></tr></thead>
                <tbody>
                  {leaderboard.map((row, i) => (
                    <tr key={i} className={i === 0 ? 'r-jackpot' : ''}>
                      <td>{i + 1}</td>
                      <td><strong>{row.username}</strong></td>
                      <td>{row.spin_count}</td>
                      <td>{row.jackpots > 0 ? 'x' + row.jackpots : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </aside>
      </div>
      </div>
    </div>
  );
}
